<template>
  <q-page padding>
    <PageHeader :backRoute="{ name: 'home' }" backBehavior="route">
      <template #title> Verificacao Facial </template>
      <template #actions>
        <span
          class="q-ml-sm text-h6 text-weight-bold text-brand-5 texto-titulo"
        >
          -
          {{
            faceSelected
              ? faceSelected.ExternalID
              : "Selecione uma Face cadastrada"
          }}
        </span>
      </template>
    </PageHeader>
    <div
      class="row col-12 q-mt-md text-brand-5 text-weight-bold q-gutter-sm items-center"
    >
      <div class="col-md-2 col-xs-8">
        <div class="q-ml-sm text-brand-5 texto-inputs">Faces cadastradas</div>
        <q-select
          v-model="faceSelected"
          dense
          outlined
          class="select q-mt-sm q-mb-sm"
          label="Digite o nome para pesquisar"
          :options="faceList"
          option-label="ExternalID"
          option-value="id"
          map-options
        />
      </div>
      <div>
        <q-toggle
          class="texto-toggle"
          v-model="livesCheck"
          label="LivenessCheck"
        />
      </div>

      <!--<div class="col-md-2 col-xs-8">
          <div class="q-ml-sm text-brand-5 texto-inputs">Selecionar Camera</div>
         
          <q-select
            v-model="deviceSelected"
            dense
            outlined
            class="select q-mt-sm q-mb-sm"
            label="Digite o nome para pesquisar"
            :options="devicesList"
            option-label="label"
            
          />
        </div>-->
    </div>

    <div class="print-container">
      <q-icon
        name="verified"
        v-if="sendSucess"
        color="positive"
        class="q-mt-xl"
        size="200px"
      />

      <video v-if="esconderCaptura" class="faceCapture" autoplay></video>
      <q-btn
        v-if="esconderCaptura"
        :disable="!faceSelected"
        label="Capturar"
        class="q-mt-md q-ml-sm"
        color="secondary"
        icon="visibility"
        @click="screenShot"
      />

      <canvas
        v-show="!esconderCaptura && sendSucess != true"
        style="height: 100%; width: 50%"
        class="canvasFace q-mt-md"
      ></canvas>
      <div v-if="!esconderCaptura" class="row q-mt-md">
        <q-btn
          v-if="sendSucess != true"
          :disable="!faceSelected"
          label="Enviar"
          class="q-ml-sm"
          color="positive"
          icon="add"
          @click="VerificarFace"
        />
        <q-btn
          :disable="!faceSelected"
          label="Tirar novamente"
          class="q-ml-sm"
          color="secondary"
          icon="refresh"
          @click="screenRepeat"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    PageHeader,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const faceSelected = ref(null);
    const devicesList = ref([]);
    const sendSucess = ref(false);
    const deviceSelected = ref("");
    const esconderCaptura = ref(true);
    const faceSend = ref(null);
    const livesCheck = ref(false);
    const contrains = ref({
      video: {
        width: {
          min: 1280,
          ideal: 1920,
          max: 1920,
        },
        height: {
          min: 720,
          ideal: 1080,
          max: 1080,
        },
      },
    });
    const faceList = ref([]);

    const getUserImage = async () => {
      const video = document.querySelector(".faceCapture");

      if (
        "mediaDevices" in navigator &&
        "getUserMedia" in navigator.mediaDevices
      ) {
        await navigator.mediaDevices
          .getUserMedia({
            ...contrains.value,
          })
          .then((stream) => {
            video.srcObject = stream;
            video.play();
          });
      }
    };

    const screenShot = async () => {
      const canvas = document.querySelector(".canvasFace");
      const video = document.querySelector(".faceCapture");

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext("2d").drawImage(video, 0, 0);
      canvas.src = canvas.toDataURL("image/webp");

      faceSend.value = canvas.toDataURL("image/jpeg", 0.9).slice(23);
      esconderCaptura.value = false;
    };

    const getFacesList = async (val) => {
      try {
        let response = await store.dispatch("facialStore/getFacesList", {
          search: val,
        });
        faceList.value = response.data.faces;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar faceSelecteds",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getFacesList);

    const getDevices = async () => {
      const devices = await navigator.mediaDevices.enumerateDevices();

      devicesList.value = devices.filter((value) => {
        if (value.label != "") {
          return { id: value.deviceId, label: value.label };
        }
      });
    };

    onMounted(getDevices);

    const screenRepeat = async () => {
      sendSucess.value = false;
      esconderCaptura.value = true;

      if (
        "mediaDevices" in navigator &&
        "getUserMedia" in navigator.mediaDevices
      ) {
        const stream = await navigator.mediaDevices.getUserMedia({
          ...contrains.value,
        });
        const video = document.querySelector(".faceCapture");
        video.srcObject = stream;

        video.play();
      }
    };

    const VerificarFace = async () => {
      try {
        await store.dispatch("facialStore/verificarFacial", {
          id: faceSelected.value.ExternalID,
          base64_image: faceSend.value,
          livesCheck: livesCheck.value,
        });

        quasar.notify({
          message: "Ha verificação foi um sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        sendSucess.value = true;
      } catch (error) {
        quasar.notify({
          message: "Rosto não compativel",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    watch([() => faceSelected.value], () => {
      getUserImage();
    });

    return {
      getUserImage,
      faceSelected,
      faceList,
      devicesList,
      deviceSelected,
      getFacesList,

      screenShot,
      esconderCaptura,
      screenRepeat,
      VerificarFace,
      sendSucess,
      livesCheck,
    };
  },
};
</script>

<style scoped>
.print-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

video {
  width: 50%;
  height: 100%;
}
</style>
